module.exports = __webpack_public_path__ + "static/media/screenshare.52dc043d.gif";